import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

interface IRequireTag {
  message?: string
  className?: string
}

export const RequireTag = ({ message, className }: IRequireTag) => {
  const {t} = useTranslation()
  return (
    <Tag className={className} style={{ fontSize: '12px', marginLeft: '4px' }} color="#ff4d4f">
      {message || t('common.required')}
    </Tag>
  )
}
